var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 1H3C1.895 1 1 1.895 1 3V17C1 18.105 1.895 19 3 19H17C18.105 19 19 18.105 19 17V3C19 1.895 18.105 1 17 1ZM7 15H4.477V8H7V15ZM5.694 6.717C4.923 6.717 4.408 6.203 4.408 5.517C4.408 4.831 4.922 4.317 5.779 4.317C6.55 4.317 7.065 4.831 7.065 5.517C7.065 6.203 6.551 6.717 5.694 6.717ZM16 15H13.558V11.174C13.558 10.116 12.907 9.872 12.663 9.872C12.419 9.872 11.605 10.035 11.605 11.174C11.605 11.337 11.605 15 11.605 15H9.082V8H11.605V8.977C11.93 8.407 12.581 8 13.802 8C15.023 8 16 8.977 16 11.174V15Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f4084be09738a6a03723f3da7c3997b0.svg";
export { ForwardRef as ReactComponent };